module.exports = {
  saveForLater: 'Uložiť na neskôr',
  saveApplication: 'Uložiť prihlášku',
  continue: 'Pokračovať',
  back: 'Späť',
  yes: 'Áno',
  no: 'Nie',
  close: 'Zatvoriť',
  select: 'Vybrať',
  selected: 'Vybrané',
  applicationLoading: 'Načítavam aplikáciu',
  savingApplication: 'Ukladám prihlášku',
  savingFamilyApplication: 'Prebieha ukladanie prihlášok. Môže to trvať niekoľko sekúnd. Nevypínajte prehliadač.',
  insured: 'Poistenec',
  insureAnotherPerson: 'Poistiť ďalšiu osobu',
  slovakRepublic: 'Slovenská republika',
  slovakia: 'Slovensko',
  abroad: 'zahraničie',
  addAnotherPerson: 'Pridať ďalšiu osobu',
  unionInformation: 'Informácie o poisťovateľovi',
  gdpr: 'Ochrana osobných údajov',
  notAvailable: 'Ospravedlňujeme sa, služba je aktuálne nedostupná.',
  notFoundParagraph1: 'Mrzí nás to, ale hľadaná stránka sa nenašla.',
  notFoundParagraph2: 'Stránka bola odstránená, premiestnená alebo premenovaná.',
  notFoundParagraph3: 'Čo môžete teraz spraviť?',
  notFoundListItem1: 'ak ste adresu zadali do prehliadača manuálne, môžete skontrolovať preklepy',
  notFoundListItem2: 'ak ste adresu skopírovali a vložili, môžete skontrolovať, či ste ju skopírovali celú',
  notFoundListItem3: 'ak ste zadali adresu správne alebo ste klikli na odkaz na webe,',
  contactUs: 'kontaktujte nás',
  day: 'Deň',
  month: 'Mesiac',
  year: 'Rok',
  remove: 'Odstrániť',
  customerCentre: 'Zákaznícke centrum',
  mondayFriday: 'Po-Pia',
  usefulLinks: 'Užitočné odkazy',
  cookiesSettings: 'Nastavenie cookies',
  aboutUs: 'O nás',
  optional: 'nepovinné',
  edit: 'Upraviť',
  otherAddress: 'Iná adresa',
};
